import axios from "axios";
import { API_BASE } from "../../config/env";

export const FETCH_GETMSS_FULFILLED = "FETCH_GETMSS_FULFILLED";
export const FETCH_GETMSS_REJECTED = "FETCH_GETMSS_REJECTED";
export const FETCH_GETMSS_PENDING = "FETCH_GETMSS_PENDING";
export const RESET_GETMSS = "RESET_GETMSS";


export function getMSS(Agreement, OtpCode) {
  const token = localStorage.getItem("accessToken")
  return dispatch => {
    dispatch({
      type: "FETCH_GETMSS",
      payload: axios({
        method: "get",
        url: `https://shop.onedose.io/gate/blog/article/mesafeli-satis-sozlesmesi,render`,
        headers: {
          "Authorization": "Bearer " + token,
          "Accept-Language": "tr-tr",
          "Client-Id": localStorage.getItem("One-Id"),
          "One-Id": localStorage.getItem("Client-Id"),
          "Content-Type": "application/json",
          "Cart-Type": "fast-checkout"
        },
      }).then((result) => result.data),
    });
  };
}

export function resetGetMSS() {
  return (dispatch) => {
    dispatch({
      type: "RESET_GETMSS",
    });
  };
}